import React, { useState } from "react";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TextField } from "@mui/material";
import dayjs from "dayjs";

const AddBranchForm = () => {
  const [startTime, setStartTime] = useState(dayjs().hour(9).minute(0));
  const [endTime, setEndTime] = useState(dayjs().hour(21).minute(0));

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Branch submitted");
    console.log("Start Time:", startTime?.format("HH:mm"));
    console.log("End Time:", endTime?.format("HH:mm"));
    // API call to save branch
  };

  return (
<div className="min-h-screen bg-gray-50 p-4">
  <div className="max-w-full mx-auto">
    {/* Form Container */}
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
      {/* Header */}
      <div className="py-3 px-5 border-b border-gray-200">
        <h2 className="text-lg font-semibold text-gray-800">Basic Information</h2>
      </div>

      <div className="py-3 px-5">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <form onSubmit={handleSubmit} className="space-y-4">
            {/* Row 1: Branch ID & Branch Name */}
            <div className="flex flex-wrap -mx-2">
              <div className="w-full lg:w-1/2 px-3 mb-2">
                <label className="block text-sm text-gray-700 font-medium mb-1">
                  Branch ID <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="branchId"
                  placeholder="Enter branch ID"
                  className="w-full border border-gray-300 rounded-md px-3 py-1.5 text-sm text-gray-700 placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                  required
                />
              </div>

              <div className="w-full lg:w-1/2 px-3 mb-2">
                <label className="block text-sm text-gray-700 font-medium mb-1">
                  Branch Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="branchName"
                  placeholder="Enter branch name"
                  className="w-full border border-gray-300 rounded-md px-3 py-1.5 text-sm text-gray-700 placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                  required
                />
              </div>
            </div>

            {/* Row 2: Location & Pharmacist In-Charge */}
            <div className="flex flex-wrap -mx-2">
              <div className="w-full lg:w-1/2 px-3 mb-2">
                <label className="block text-sm text-gray-700 font-medium mb-1">
                  Location
                </label>
                <input
                  type="text"
                  name="location"
                  placeholder="Enter location"
                  className="w-full border border-gray-300 rounded-md px-3 py-1.5 text-sm text-gray-700 placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>

              <div className="w-full lg:w-1/2 px-3 mb-2">
                <label className="block text-sm text-gray-700 font-medium mb-1">
                  Pharmacist In-Charge
                </label>
                <input
                  type="text"
                  name="pharmacist"
                  placeholder="Enter pharmacist name"
                  className="w-full border border-gray-300 rounded-md px-3 py-1.5 text-sm text-gray-700 placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
            </div>

            {/* Row 3: Contact Number & Email */}
            <div className="flex flex-wrap -mx-2">
              <div className="w-full lg:w-1/2 px-3 mb-2">
                <label className="block text-sm text-gray-700 font-medium mb-1">
                  Contact Number
                </label>
                <input
                  type="tel"
                  name="contact"
                  placeholder="Enter contact number"
                  className="w-full border border-gray-300 rounded-md px-3 py-1.5 text-sm text-gray-700 placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>

              <div className="w-full lg:w-1/2 px-3 mb-2">
                <label className="block text-sm text-gray-700 font-medium mb-1">
                  Email
                </label>
                <input
                  type="email"
                  name="email"
                  placeholder="Enter email address"
                  className="w-full border border-gray-300 rounded-md px-3 py-1.5 text-sm text-gray-700 placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
            </div>

            {/* Row 4: Start Time & End Time */}
            <div className="flex flex-wrap -mx-2">
              <div className="w-full lg:w-1/2 px-3 mb-2">
                <label className="block text-sm text-gray-700 font-medium mb-1">
                  Start Time
                </label>
                <TimePicker
                  className="w-100"
                  value={startTime}
                  onChange={(newValue) => setStartTime(newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      placeholder="Select start time"
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          '& fieldset': {
                            borderColor: '#d1d5db',
                            borderRadius: '6px',
                          },
                          '&:hover fieldset': { borderColor: '#3b82f6' },
                          '&.Mui-focused fieldset': {
                            borderColor: '#3b82f6',
                            borderWidth: '1px',
                          },
                        },
                        '& .MuiInputBase-input': {
                          padding: '6px 10px',
                          fontSize: '0.875rem',
                          color: '#374151',
                        },
                      }}
                    />
                  )}
                />
              </div>

              <div className="w-full lg:w-1/2 px-3 mb-2">
                <label className="block text-sm text-gray-700 font-medium mb-1">
                  End Time
                </label>
                <TimePicker
                  className="w-100"
                  value={endTime}
                  onChange={(newValue) => setEndTime(newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      placeholder="Select end time"
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          '& fieldset': {
                            borderColor: '#d1d5db',
                            borderRadius: '6px',
                          },
                          '&:hover fieldset': { borderColor: '#3b82f6' },
                          '&.Mui-focused fieldset': {
                            borderColor: '#3b82f6',
                            borderWidth: '1px',
                          },
                        },
                        '& .MuiInputBase-input': {
                          padding: '6px 10px',
                          fontSize: '0.875rem',
                          color: '#374151',
                        },
                      }}
                    />
                  )}
                />
              </div>
            </div>

            {/* Row 5: Status */}
            <div className="flex flex-wrap -mx-2">
              <div className="w-full px-3 mb-2">
                <label className="block text-sm text-gray-700 font-medium mb-1">
                  Status
                </label>
                <select
                  name="status"
                  className="w-full border border-gray-300 rounded-md px-3 py-1.5 text-sm text-gray-500 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 appearance-none bg-white"
                >
                  <option value="">Select status</option>
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                  <option value="Under Construction">Under Construction</option>
                  <option value="Maintenance">Under Maintenance</option>
                </select>
              </div>
            </div>

            {/* Row 6: Additional Notes */}
            <div className="flex flex-wrap -mx-2">
              <div className="w-full px-3 mb-2">
                <label className="block text-sm text-gray-700 font-medium mb-1">
                  Additional Notes
                </label>
                <textarea
                  name="notes"
                  placeholder="Enter additional notes or special instructions"
                  rows="3"
                  className="w-full border border-gray-300 rounded-md px-3 py-1.5 text-sm text-gray-700 placeholder-gray-500 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500 resize-none"
                ></textarea>
              </div>
            </div>
          </form>
        </LocalizationProvider>
      </div>

      {/* Footer */}
      <div className="bg-gray-50 px-6 py-3 border-t border-gray-200 rounded-b-lg">
        <div className="flex justify-end gap-2">
          <button type="button" className="gradient-dark-button text-sm px-3 py-1.5">
            Reset
          </button>
          <button
            type="submit"
            onClick={handleSubmit}
            className="gradient-button text-sm px-3 py-1.5"
          >
            Add Branch
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

  );
};

export default AddBranchForm;
